import { render, staticRenderFns } from "./FilesPreview.vue?vue&type=template&id=141be3ec&"
import script from "./FilesPreview.vue?vue&type=script&lang=js&"
export * from "./FilesPreview.vue?vue&type=script&lang=js&"
import style0 from "./FilesPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports